import { useNavigate } from "react-router-dom"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge"
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow"

const Admins = () => {

  const navigate = useNavigate()

  const statsData = [
    { title: "Total aDMINS".toUpperCase(), value: 0 },
    { title: "Active Admins".toUpperCase(), value: 0 },
    { title: "Total Roles".toUpperCase(), value: 0 },
    { title: "Total Permissions".toUpperCase(), value: 0 },
  ]

  const tableData = [
    { adminID: '01', roleID: 2, email: 'loremipsum@gmail.com', status: 'Active', createdAt: '05/12/2024', lastLogin: '05/12/2024' },
    { adminID: '01', roleID: 2, email: 'loremipsum@gmail.com', status: 'Inactive', createdAt: '05/12/2024', lastLogin: '05/12/2024' },
    { adminID: '01', roleID: 2, email: 'loremipsum@gmail.com', status: 'Active', createdAt: '05/12/2024', lastLogin: '05/12/2024' },
    { adminID: '01', roleID: 2, email: 'loremipsum@gmail.com', status: 'Inactive', createdAt: '05/12/2024', lastLogin: '05/12/2024' },
    { adminID: '01', roleID: 2, email: 'loremipsum@gmail.com', status: 'Active', createdAt: '05/12/2024', lastLogin: '05/12/2024' },
  ]

  const columns = [
    { name: 'Admin ID', selector: row => row.adminID, grow: 0.5 },
    { name: 'Role ID', selector: row => row.roleID, grow: 0.5 },
    { name: 'Email', selector: row => row.email },
    { name: 'Status', cell: row => <StatusBadge statusName={row.status} /> },
    { name: 'Created At', selector: row => row.createdAt },
    { name: 'Last Login', selector: row => row.lastLogin },
  ]

  return (
    <>
      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="fw-semibold fs-5 mb-2">Overview</div>
        <DynamicCardRow cards={statsData} />
      </div>

      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="fw-semibold fs-5">All Admins</div>
          <DynamicButton theme="blue" onClick={() => navigate("/user-management/admins/add-new-admin")}>
            Add new
          </DynamicButton>
        </div>
      </div>

      <DynamicDatatable data={tableData} columns={columns} type='yellow' pagination />

    </>
  )
}

export default Admins
